// Centralized site constants (Slovenian insurance agent)
export const AGENT = {
  name: "Jan Pestelj",
  title: "Osebni svetovalec",
  company: "Osebna Varnost",
  phone: "+386 70 802 088",
  whatsapp: "38670802088", // E.164 brez "+"
  email: "info@osebna-varnost.com",
  hoursInfo: "Informacije: 7.00 – 22.00",
  hoursEmergency: "Nujni škodni dogodki: 24/7",
};

// Storitve so organizirane v tri logične sklope.
export const SERVICE_GROUPS = [
  {
    key: "general",
    title: "Splošne rešitve",
    subtitle: "Pravna in administrativna pomoč ob izzivih z zavarovalnicami.",
    services: [
      {
        key: "claims",
        title: "Odškodninski primeri",
        desc: "Pomoč pri uveljavi odškodnin po prometnih nesrečah in telesnih poškodbah.",
        icon: "Scale",
      },
      {
        key: "challenges",
        title: "Pomoč pri izzivih",
        desc: "Razlaga pogojev, uveljava drugih zahtevkov in informacije, ko se zatakne.",
        icon: "Compass",
      },
      {
        key: "policy_review",
        title: "Pregled polic",
        desc: "Brezplačen pregled obstoječih zavarovanj. Pokažem, kje plačujete preveč ali kje nimate kritja.",
        icon: "FileSearch",
      },
    ],
  },
  {
    key: "protection",
    title: "Zaščitni del",
    subtitle: "Zavarovanja, ki ščitijo vas, družino in premoženje pred tveganji.",
    services: [
      {
        key: "auto",
        title: "Avtomobilska zavarovanja",
        desc: "Obvezno, kasko, asistenca. Primerjamo ponudbe in najdemo najboljši paket za vas in vaše vozilo.",
        icon: "Car",
      },
      {
        key: "absence",
        title: "Daljša odsotnost z dela",
        desc: "Zavarovanje za primer bolniške, invalidnosti ali izgube dohodka — vaš mesečni proračun ostane zaščiten.",
        icon: "BriefcaseMedical",
      },
      {
        key: "health",
        title: "Zdravstvena zavarovanja",
        desc: "Hitrejši dostop do zdravnikov in možnosti zdravljenja bolezni v tujini — do zdravnika v parih dneh.",
        icon: "HeartPulse",
      },
      {
        key: "personal",
        title: "Osebna zavarovanja",
        desc: "Življenjsko, nezgodno in zavarovanje kritičnih bolezni — finančna varnost za vas in vaše bližnje.",
        icon: "ShieldCheck",
      },
    ],
  },
  {
    key: "wealth",
    title: "Plemenitenje",
    subtitle: "Dolgoročno gradite premoženje in poskrbite za pokojnino.",
    services: [
      {
        key: "pension",
        title: "Varčevanje za pokojnino",
        desc: "Davčno ugodno dolgoročno varčevanje. Pripravimo načrt, da bo pokojnina dejansko dovolj.",
        icon: "PiggyBank",
      },
      {
        key: "longterm",
        title: "Dolgoročno varčevanje z donosi",
        desc: "Dodatne možnosti kot so predujem brez prodaje enot ali dostop do ekskluzivnih skladov — JP Morgan, BlackRock, Fidelity…",
        icon: "TrendingUp",
      },
    ],
  },
];

// Flat seznam za izbire (npr. kontaktni obrazec)
export const SERVICES = SERVICE_GROUPS.flatMap((g) => g.services);

// Predlogi razreda poškodb za kalkulator
export const INJURY_TIERS = [
  { range: "1–4 %", label: "Blage poškodbe", min: 1, max: 4 },
  { range: "5–8 %", label: "Resnejše poškodbe", min: 5, max: 8 },
  { range: "8–20 %", label: "Hujše poškodbe", min: 8, max: 20 },
  { range: "21–50 %", label: "Zelo hude poškodbe", min: 21, max: 50 },
  { range: "51 % +", label: "Poškodbe z invalidskimi omejitvami", min: 51, max: 100 },
];

// Mnenja strank — naložimo iz API-ja; placeholder je prazen.
export const TESTIMONIALS = [];
